export interface Category {
  slug: string;
  name: string;
  en: string;
  tagline: string;
  blurb: string;
  cover: string;
  stat: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'huati',
    name: '热门话题',
    en: 'Topics',
    tagline: '正在发酵的讨论场',
    blurb: '从生活方式到社会议题，把散落在各处的讨论整理成一条条清晰的脉络，方便你快速跟上大家在聊什么。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20floating%20conversation%20bubbles%20and%20speech%20cards%20in%20terracotta%20orange%20and%20cream%20tones%2C%20soft%20flat%20shapes%2C%20subtle%20grain%20texture%2C%20clean%20composition%2C%20modern%20magazine%20cover%20aesthetic&width=760&height=520&seq=cat-huati&orientation=landscape',
    stat: '126 条',
    icon: 'ri-chat-3-line',
  },
  {
    slug: 'shijian',
    name: '热点事件',
    en: 'Events',
    tagline: '完整梳理事件始末',
    blurb: '把一场场热点事件的时间线、关键节点与多方声音抽丝剥茧，还原前因后果，拒绝只言片语式的碎片信息。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20a%20timeline%20of%20pinned%20notes%20and%20magnifying%20glass%20on%20a%20corkboard%2C%20terracotta%2C%20rust%20and%20cream%20tones%2C%20flat%20soft%20shapes%2C%20subtle%20grain%2C%20clean%20journalistic%20composition&width=760&height=520&seq=cat-shijian&orientation=landscape',
    stat: '98 条',
    icon: 'ri-focus-3-line',
  },
  {
    slug: 'renwu',
    name: '人物动态',
    en: 'People',
    tagline: '新锐面孔与行业关键人',
    blurb: '关注各行业里正在被讨论的人物与新锐面孔，梳理他们的观点、轨迹与代表作品，看见人，也看见背后的选择。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20abstract%20human%20portrait%20silhouette%20built%20from%20geometric%20shapes%20and%20speech%20marks%2C%20terracotta%20orange%20and%20cream%2C%20soft%20flat%20style%2C%20subtle%20grain%20texture%2C%20modern%20portrait%20magazine%20aesthetic&width=760&height=520&seq=cat-renwu&orientation=landscape',
    stat: '74 条',
    icon: 'ri-user-heart-line',
  },
  {
    slug: 'jigou',
    name: '机构观察',
    en: 'Organizations',
    tagline: '品牌平台与机构的动向',
    blurb: '追踪品牌、平台与机构的真实动作与经营观察，结合公开信息整理，帮助你判断风向，也帮你避坑。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20stacked%20buildings%20and%20columns%20with%20rising%20trend%20chart%20in%20rust%20and%20cream%20tones%2C%20flat%20soft%20geometric%20shapes%2C%20subtle%20grain%2C%20clean%20institutional%20magazine%20composition&width=760&height=520&seq=cat-jigou&orientation=landscape',
    stat: '61 条',
    icon: 'ri-building-4-line',
  },
];

export const getCategory = (slug: string): Category | undefined =>
  categories.find((c) => c.slug === slug);